@import 'ss-ui-client/src/constants/spacing.module.less';

.drawer-body {
  height: 100%;
  overflow: auto;
  padding: 0;
}

.workflow-canvas {
  padding: @space-24 0;
}

.drawer-header {
  background-color: var(--white);
}

.textarea {
  height: 150px;
  padding: @space-8;
  font-size: 14px;
}

.drawer-footer {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: @space-16 @space-24;
  border-top: 1px solid var(--grey-300);
  background-color: var(--white);
}

.delete-button,
.delete-button:hover {
  color: var(--error--button--text-color--1);
}
